import type { InternalApiKeysTranslations } from "../interfaces/internalApiKeys";

export const internalApiKeysTranslations: InternalApiKeysTranslations = {
  page_title: "Chaves internas",
  page_subtitle:
    "Chaves para que os sistemas da Coloca, como o CRM, usem a API interna sem usuário e senha. Cada alteração pede o seu código de verificação, exceto desativar ou revogar.",
  action_refresh: "Atualizar",
  action_new: "Nova chave",
  action_retry: "Tentar novamente",
  surface_off: "A API interna está desativada neste ambiente. As chaves não respondem até que seja ativada.",
  access_failed: "Não conseguimos verificar o seu acesso às chaves internas. Tente novamente em instantes.",

  empty_title: "Ainda não há chaves internas",
  empty_description: "Crie uma para que o CRM deixe de entrar com usuário e senha.",

  status_ACTIVE: "Ativa",
  status_DISABLED: "Desativada",
  status_NO_IP: "Sem IP",
  status_EXPIRED: "Vencida",
  status_REVOKED: "Revogada",

  row_all_organizations: "Todas as organizações",
  row_organizations_one: "1 organização",
  row_organizations_other: "{{count}} organizações",
  row_permissions_all: "Permissões: todas",
  row_permissions: "Permissões: {{list}}",
  row_no_ip: "Sem IP permitido",
  row_ips: "IP {{ips}}",
  row_no_ip_low_risk: "Sem IP (titulares de qualquer IP)",
  row_ips_low_risk: "IP {{ips}} · titulares de qualquer IP",
  row_expires: "Vence em {{date}}",
  row_expired: "Venceu em {{date}}",
  row_revoked: "Revogada em {{date}}",
  row_last_used: "Último uso {{date}} a partir de {{ip}}",
  row_never_used: "Ainda sem uso",
  row_rotation_grace: "O segredo anterior funciona até {{date}}",
  switch_label: "Ativar ou desativar {{name}}",
  switch_needs_ip: "Adicione um IP para ativá-la",
  switch_needs_expiry: "Estenda o vencimento para ativá-la",
  menu_label: "Ações de {{name}}",

  action_edit: "Editar",
  action_edit_ips: "Editar IPs",
  action_rotate: "Trocar o segredo",
  action_usage: "Ver o uso",
  action_revoke: "Revogar",
  cancel: "Cancelar",

  toast_created: "Chave criada",
  toast_updated: "Alterações salvas",
  toast_ips_updated: "IPs salvos",
  toast_enabled: "Chave ativada",
  toast_disabled: "Chave desativada",
  toast_rotated: "Segredo trocado",
  toast_revoked: "Chave revogada",

  revoke_title: "Revogar {{name}}?",
  revoke_description:
    "Deixa de funcionar na hora e não pode ser usada de novo. O sistema que a usa recebe 404 até ter uma chave nova.",
  revoke_confirm: "Revogar",
  rotate_title: "Trocar o segredo de {{name}}?",
  rotate_description_grace:
    "Um segredo novo é gerado. O anterior continua funcionando por {{hours}} horas para que o sistema que a usa consiga trocá-lo.",
  rotate_description_now: "Um segredo novo é gerado e o anterior deixa de funcionar na hora.",
  rotate_retire_now_label: "O segredo vazou: parar de aceitar o anterior agora",
  rotate_retire_now_hint: "O sistema que usa a chave falha até receber o segredo novo.",
  rotate_confirm: "Trocar o segredo",

  token_title_created: "Copie a chave de {{name}} agora",
  token_title_rotated: "Copie o segredo novo de {{name}} agora",
  token_warning:
    "Ela não é mostrada de novo. Envie por um gerenciador de segredos ou de senhas, nunca por chat ou e-mail.",
  token_copy: "Copiar",
  token_copied: "Copiada",
  token_dismiss: "Já guardei",

  form_title_create: "Nova chave interna",
  form_title_edit: "Editar {{name}}",
  form_description: "O que a chave pode fazer, em quais organizações e de qual IP.",
  field_name: "Nome",
  field_name_placeholder: "CRM",
  field_description: "Para que serve (opcional)",
  section_permissions: "Permissões",
  all_permissions_label: "Todas as permissões",
  all_permissions_hint: "Inclui as que forem adicionadas à API interna depois.",
  permission_operation_payments_read: "Ver ordens de pagamento",
  permission_operation_payments_create: "Criar ordens de pagamento",
  permission_operation_payments_cancel: "Cancelar ordens pendentes",
  permission_clients_read: "Ver clientes",
  permission_clients_write: "Criar e editar clientes",
  permission_client_accounts_write: "Registrar contas de clientes",
  permission_cardholders_write: "Cadastrar titulares (e reenviar o registro)",
  section_organizations: "Organizações",
  all_organizations_label: "Todas as organizações",
  all_organizations_hint: "A chave poderá criar e ler ordens e clientes de qualquer organização.",
  organizations_add: "Adicionar organização",
  organizations_add_hint: "Fora destas organizações a chave recebe 404.",
  organizations_remove: "Remover {{name}}",
  section_ips: "IPs permitidos",
  ips_hint:
    "IPs públicos exatos, até 10. Sem IP a chave só pode ser ativada se permitir o cadastro de titulares de qualquer IP.",
  allow_without_ip_label: "Permitir o cadastro de titulares de qualquer IP",
  allow_without_ip_hint:
    "Apenas para cadastrar titulares e reenviar o registro. Pagamentos e clientes continuam exigindo um IP da lista.",
  ip_label: "IP",
  ip_placeholder: "54.213.10.45",
  ip_label_placeholder: "Rótulo (opcional)",
  ip_add: "Adicionar",
  ip_remove: "Remover {{ip}}",
  ip_invalid: "Digite um IP válido (IPv4 ou IPv6), sem faixas.",
  ip_duplicate: "Esse IP já está na lista.",
  ips_dialog_title: "IPs de {{name}}",
  ips_dialog_submit: "Salvar IPs",
  ips_dialog_turns_off: "Sem IPs a chave é desligada ao salvar e não pode ser ligada até você adicionar um.",
  ips_dialog_only_cardholders:
    "Sem IPs a chave só poderá cadastrar titulares. Pagamentos e clientes receberão 404.",
  section_limits: "Vencimento e limite",
  field_expires_on: "Funciona até",
  field_expires_hint: "No máximo {{days}} dias a partir de hoje.",
  field_rate_limit: "Solicitações por minuto",
  field_rate_limit_hint: "Passado o limite responde 429 até o minuto seguinte.",
  error_name: "Digite um nome com pelo menos 3 caracteres.",
  error_permissions: "Escolha pelo menos uma permissão, ou todas.",
  error_organizations: "Escolha pelo menos uma organização, ou todas.",
  error_expiry: "Escolha até quando funciona.",
  error_rate_limit: "Digite um número entre 1 e 6000.",
  error_ips: "Até 10 IPs.",
  form_submit_create: "Criar chave",
  form_submit_edit: "Salvar alterações",

  two_factor_required: "Para criar ou alterar chaves internas você precisa da verificação em duas etapas.",
  two_factor_challenge: "Digite o código do seu app autenticador para confirmar.",

  usage_title: "Uso de {{name}}",
  usage_description: "Cada solicitação que chegou com esta chave, inclusive as recusadas.",
  usage_empty: "Ainda sem solicitações",
  usage_status: "HTTP {{code}}",
  outcome_OK: "Aceita",
  outcome_SURFACE_OFF: "API interna desativada",
  outcome_ORIGIN_REJECTED: "Veio de um navegador",
  outcome_MISSING_KEY: "Sem chave",
  outcome_MALFORMED_KEY: "Chave com formato inválido",
  outcome_WRONG_ENV: "Chave de outro ambiente",
  outcome_UNKNOWN_KEY: "Chave desconhecida",
  outcome_BAD_SECRET: "Segredo incorreto",
  outcome_REVOKED: "Chave revogada",
  outcome_DISABLED: "Chave desativada",
  outcome_EXPIRED: "Chave vencida",
  outcome_IP_BLOCKED: "IP não permitido",
  outcome_SERVICE_USER_INACTIVE: "Usuário de serviço inativo",
  outcome_FORBIDDEN: "Sem permissão para essa operação",
  outcome_RATE_LIMITED: "Passou do limite por minuto",
  outcome_ERROR: "Erro ao verificar a chave",
};
